export default "__VITE_ASSET__lMad2VFv__"